import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from '@fortawesome/free-solid-svg-icons'
import "./Header.css"
import { useNavigate } from "react-router-dom"

function Header(){
    const navigate = useNavigate()
    return(
        <div className="header">
            <div className="menu" onClick={()=>{navigate("/")}}>
                <FontAwesomeIcon icon={faBars} size="3x" color="#fff"/>
            </div>
            <img className="logo" src={require("../assets/logo.png")} alt="Hacienda de Los Morales"/>
        </div>
    )
}

export default Header